// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import PaperClipOutlinedSvg from "@ant-design/icons-svg/lib/asn/PaperClipOutlined";
import AntdIcon from "../components/AntdIcon";
const PaperClipOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: PaperClipOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    PaperClipOutlined.displayName = "PaperClipOutlined";
}
export default /*#__PURE__*/ React.forwardRef(PaperClipOutlined);
